export default __webpack_public_path__ + "static/media/cooling-unit.a8f6782a.jpeg";